<template lang="pug">
div
  portal(
    v-if="!loading"
    to="course-title"
  )
    .d-flex.align-center.mb-4
      v-btn.ml-n2.px-2(
        color="primary"
        text exact
        :to=`{
          name: 'EducationLessonList',
          params: {
            courseId: courseId,
          }
        }`
      )
        v-icon(left) mdi-arrow-left
        span Назад
      v-chip(color="secondary" outlined).px-3.ml-auto
        span.mr-2 {{ $conf.LESSON_TYPE_NAMES[lesson.type] }}
        v-icon(size="21") mdi-school-outline
    .text-h6.mb-3 {{ lesson.name }}
    .text-body-2.mb-4 {{ lesson.description }}

    v-list-item.mb-6.ml-n2.px-2(
      :disabled="lesson.user_passed"
      @click.stop="lesson.openChatAsStudent()"
    )
      v-list-item-action.mr-4: v-badge(
        :value="lesson.hasConsultationMessages"
        color="error"
        size="10"
        overlap
        dot
        bordered
      ): v-icon(:color="lesson.user_passed ? '' : 'primary'") mdi-forum
      v-list-item-content.text-body-2: strong  Консультация по уроку

  v-fade-transition(mode="out-in")
    div(v-if="!loading")
      .mb-6(v-if="meetings.length")
        .text-body-1.mb-4
          strong Трансляции
          span.text-body-2.ml-2.grey--text {{ meetings.length }}
        lesson-meeting-card.my-3(
          v-for="meeting in meetings"
          :key="meeting.id"
          :meeting="meeting"
          :is-teacher="isTeacher"
        )

      //- template()
      //-   h3.my-3 Материалы урока
      //-   v-sheet.align-center.mb-8(
      //-     v-for="video in lessonMaterials.links"
      //-     :key="video.id"
      //-     max-width="560px"
      //-   )
      //-     video-player(
      //-       v-if="lessonMaterials.links"
      //-       :video="video"
      //-     )
      //-     h4.pl-2 {{ video.name }}
      //-     p.pl-2 {{ video.description }}
      template(v-if="Object.values(lessonMaterials).flat().length")
        .text-body-1.mb-4
          strong Материалы урока
          span.text-body-2.ml-2.grey--text {{ Object.values(lessonMaterials).flat().length }}

        v-expansion-panels.mb-8(
          v-model="panels"
          flat accordion
        )
          v-list-item.sdo-radius.sdo-shadow.mb-4(
            v-for="link in lessonMaterials.telegram"
            :key="link.id"
            @click="handleTelegramLink(link.link)"
          )
            v-list-item-avatar(color="secondary" size="32")
              v-icon.pl-1(color="white" size="28") $telegram
            v-list-item-content
              .text-caption.grey--text.text--darken-1 Телеграм
              .text-body-2.card-title {{ link.name }}

          v-expansion-panel.sdo-card.mb-4(
            v-for="video in lessonMaterials.links"
            :key="video.id"
          )
            v-expansion-panel-header
              v-list-item(link)
                v-list-item-icon.mr-4.mt-3
                  v-icon(color="teal darken-1" size="28") mdi-video-outline
                v-list-item-content
                  .text-caption.grey--text.text--darken-1 Видеоурок
                  .text-body-2.card-title {{ video.name }}
                v-list-item-action: v-icon(size="20" color="primary") mdi-chevron-down
              template(v-slot:actions)
                span

            v-expansion-panel-content.pa-3
              v-sheet.align-center
                video-player.sdo-radius(
                  v-if="lessonMaterials.links"
                  :video="video" flat
                )
                p.pl-2 {{ video.description }}

          v-expansion-panel.sdo-card.mb-4(
            v-for="lecture in lessonMaterials.lecture"
            :key="lecture.id"
          )
            v-expansion-panel-header
              v-list-item(link)
                v-list-item-icon.mr-4
                  v-icon(color="blue-grey" size="28") mdi-book-open-variant-outline
                v-list-item-content
                  .text-caption.grey--text.text--darken-1 Лекция
                  .text-body-2.card-title {{ lecture.name }}
                v-list-item-action: v-icon(size="20" color="primary") mdi-chevron-down

              template(v-slot:actions)
                span
            v-expansion-panel-content.pa-3
              p(v-html="lecture.text")
              .d-flex
                v-btn.ml-auto(
                  color="primary" text small
                  @click="panels = null"
                ) Свернуть
                  v-icon(right) mdi-chevron-up

          v-list-item.sdo-radius.sdo-shadow.pr-3(
            v-for="file in lessonMaterials.files"
            :key="file.id"
            :href="file.url"
            target="_blank"
          )
            v-list-item-icon.mr-4
              v-icon(color="indigo lighten-1" size="28") mdi-file-upload-outline
            v-list-item-content
              .text-caption.grey--text.text--darken-1 Файл
              .text-body-2.card-title {{ file.name }}
            v-list-item-action: v-icon(size="18" color="primary") mdi-download

      template(v-if="lesson.tasks.length")
        .text-body-1.mb-4
          strong Задания
          span.text-body-2.ml-2.grey--text {{ lesson.tasks.length }}
        lesson-task(
          v-for="(item, taskIdx) in lesson.tasks"
          :key="item.id"
          :task="item"
          :course="course"
          :idx="taskIdx"
        )

    v-skeleton-loader.fill-width(
      v-else
      type=`card-heading,
        list-item-two-line@5
      `
    )

  v-row(no-gutters).mt-12
    v-tooltip(
      :disabled="lesson.isComplete"
      top
    )
      template(#activator="{ on }")
        div(v-on="on").fill-width
          v-btn(
            @click="openApproveDialog(lesson)"
            color="success"
            rounded
            x-large block
            :disabled="!lesson.isComplete || lesson.user_passed"
          ) {{ !lesson.user_passed ? "Завершить урок" : "Урок завершен" }}
      span {{ lessonPassedText(lesson.user_passed) }}
  .d-flex
    v-btn.ml-auto(
      v-if="nextLessonId"
      outlined
      large
      rounded
      exact
      @click="routeToNextLesson"
      :disabled="!lesson.user_passed"
      color="primary"
    ).mt-4.mb-2
      span Следующий урок
      v-icon(right size="26") mdi-chevron-right
    v-btn(
      v-else-if="!loading"
      outlined
      large exact
      rounded
      :to=`{
            name: 'EducationLessonList',
            params: {
              courseId: courseId,
            }
          }`
      color="primary"
    ).mt-4.mb-2
      v-icon(left size="26") mdi-chevron-left
      span Вернуться к теме
</template>

<script>
import { mapGetters } from 'vuex';
import { format } from 'date-fns';

import VideoPlayer from '@/components/Global/VideoPlayer.vue';
import LessonMeetingCard from '../../../components/Lessons/LessonMeetingCard.vue';
import LessonTask from '../../../components/Lessons/LessonTask.vue';

const TYPES = {
  telegram: 1,
  links: 2,
  files: 3,
  lecture: 4,
};

export default {
  name: 'LessonTaskList',
  components: {
    VideoPlayer,
    LessonMeetingCard,
    LessonTask,
  },
  props: {
    course: { type: Object, required: true },
  },
  data() {
    return {
      nextLessonId: null,
      panels: null,
      lesson: {},
      loading: false,
      meetings: null,
      TYPES,
    };
  },
  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
    }),
    daysAfterStart() {
      return true;
    },
    courseId() {
      return this.$route.params.courseId;
    },
    unitId() {
      return this.$route.params.unitId;
    },
  },
  async created() {
    await this.init();
  },
  methods: {
    async checkUserInGroup(id) {
      const { data } = await this.$api.telegram.checkUserInGroup(
        id,
        { user_id: this.$user.data.id },
      );
      return data.data.status;
    },
    async handleTelegramLink(link) {
      if (!this.$user.data.telegram) {
        this.$user.openSignUpTelegram();
      } else {
        const telegram = this.course.telegram?.find((i) => i.type === 2);
        const isInGroup = await this.checkUserInGroup(telegram.id);
        if (isInGroup) window.open(link, '_blank');
        else window.open(telegram.invite_link);
      }
    },
    async init() {
      this.loading = true;

      const params = {
        expand: 'tasks,user_attempts,group,content_links,content_files,content_lecture,content_stream,content_telegram,user_tasks',
      };

      await this.$rHandler(
        this.$api.lessons.getLesson(this.$route.params.lessonId, params),
        (res) => {
          const {
            content_links: links,
            content_files: files,
            content_lecture: lecture,
            content_telegram: telegram,
          } = res.data.data;

          this.lessonMaterials = {
            telegram,
            links,
            files,
            lecture,
          };
          return res;
        },
      );
      const query = {
        sort: '-date_start',
        'search[from_date]': format(new Date(), 'yyyy-MM-dd'),
        'search[im_learning]': true,
        'search[lesson_id]': this.$route.params.lessonId,
      };

      const { items } = await this.$api.telegram.conferenceIndex(query);

      this.meetings = items;

      const { item: unit } = await this.$api.courses.courseUnitShow(
        this.courseId,
        this.$route.params.unitId,
        { expand: 'lessons,tasks,user_passed,user_tasks' },
      );

      const lessonIdx = unit.lessons.findIndex(
        ({ id }) => id === Number(this.$route.params.lessonId),
      );
      this.lesson = unit.lessons[lessonIdx];
      this.nextLessonId = unit.lessons[lessonIdx + 1]?.id || null;
      this.loading = false;
    },

    routeToNextLesson() {
      this.$router.replace({ params: { lessonId: this.nextLessonId } });
      this.init();
    },

    lessonPassedText(isPassed) {
      return isPassed ? 'Урок завершен' : 'Завершить урок Вы сможете после того, как Ваше задание получит положительную оценку';
    },

    openApproveDialog(lesson) {
      this.$modals.show('confirm-controller', {
        message: `<p>Подтверждаете, что готовы перейти к следующему уроку? Возможность получения консультации
          у закрепленного эксперта по завершенному уроку будет отозвана.</p><p class="mt-2 font-weight-bold error--text">
          Точно все освоили?</p>`,
        method: () => this.$rHandler(
          this.$api.lessons.passLesson(lesson.id, {
            course_id: this.courseId,
          }),
          () => {
            this.lesson.user_passed = true;
            this.$toasted.success('Урок успешно завершен', { duration: 2000 });
          },
        ),
      });
    },
  },
};
</script>
